// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'acuminproRegularWebfont', 'acuminproRegularWebfont Fallback'"},"className":"__className_d622c7","variable":"__variable_d622c7"};